var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"step-heading"},[_vm._v("Step "+_vm._s(_vm.step)+" of "+_vm._s(_vm.steps)+" - "+_vm._s(_vm.stepName))]),_vm._v(" "),_c('div',{staticClass:"step-bar"},_vm._l((_vm.steps),function(stepNumber){return _c('span',{key:stepNumber,staticClass:"step-bar__step",class:{ 'step-bar__step--active': _vm.step >= stepNumber }})}),0)])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f66e3e0","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/core/components/StepBar.vue
// module id = pOE0
// module chunks = 15